<template>
	<div class="pageBottom">
		<div class="pageBottom-in">
			<div class="pageBottom-in-a">
				<div class="pageBottom-in-a-logo"></div>
				<div class="pageBottom-in-a-texta">{{$store.state.contact.copyright}}</div>
				<div class="pageBottom-in-a-textb"><a target='blank' href="http://beian.miit.gov.cn/">{{$store.state.contact.copyrightNumber}}</a></div>
			</div>
			<div class="pageBottom-in-b">
				<div class="pageBottom-in-b-item pageBottom-in-b-item-tit">快捷链接</div>
				<div class="pageBottom-in-b-item"><router-link @click.native="tapPageBottomItemNav('/about')" class="pageBottom-in-b-item" to="/about">关于我们</router-link></div>
				<div class="pageBottom-in-b-item"><router-link @click.native="tapPageBottomItemNav('/range')" class="pageBottom-in-b-item" to="/range">服务范围</router-link></div>
				<div class="pageBottom-in-b-item"><router-link @click.native="tapPageBottomItemNav('/news')" class="pageBottom-in-b-item" to="/news">新闻资讯</router-link></div>
				<div class="pageBottom-in-b-item"><router-link @click.native="tapPageBottomItemNav('/contact')" class="pageBottom-in-b-item" to="/contact">联系我们</router-link></div>
			</div>
			<div class="pageBottom-in-c">
				<div class="pageBottom-in-c-item pageBottom-in-c-item-tit">联系我们</div>
				<div class="pageBottom-in-c-item">{{$store.state.contact.address}}</div>
				<div class="pageBottom-in-c-item">{{$store.state.contact.tellphone}}</div>
				<div class="pageBottom-in-c-item">{{$store.state.contact.fax}}</div>
				<div class="pageBottom-in-c-item">{{$store.state.contact.phone}}</div>
			</div>
			<div class="pageBottom-in-d">
				<div class="pageBottom-in-d-code">
					<img :src="$store.state.website + $store.state.contact.codeimage" style="width:100%"/>
				</div>
				<div class="pageBottom-in-d-text">合作洽谈</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:'',
		data(){
			return {
				
			}
		},
		mounted() {
			let that = this;
			
			//获取联系我们数据
			that.$axios.post('http://www.sy-eray.com/index.php/api/demo/lxwm', {
				// 'aa':1
			}).then(function(response) {
				console.log(response.data.data)
				let contact = response.data.data;
				// console.log(contact)
				that.$store.commit('contact',contact);
			
			}).catch(function(error) {
				console.log(error);
			});
			
		},
		methods:{
			tapPageBottomItemNav(e){
				// console.log(e);
				this.$store.commit('path',e);
			}
		}
	}
</script>

<style>
	.pageBottom {
		width: 100%;
		height: 250px;
		background: #2e2e2e;
	}

	.pageBottom-in {
		width: 1200px;
		height: 100%;
		/* background: #444444; */
		margin: 0 auto;
	}

	.pageBottom-in-a {
		width: 600px;
		height: 100%;
		/* background: #009C41; */
		float: left;
		padding-top: 64px;
		box-sizing: border-box;
	}

	.pageBottom-in-b {
		width: 190px;
		height: 100%;
		/* background: red; */
		float: left;
		padding-top: 46px;
		box-sizing: border-box;
	}

	.pageBottom-in-c {
		width: 300px;
		height: 100%;
		/* background: #009C41; */
		float: left;
		padding-top: 46px;
		box-sizing: border-box;
	}

	.pageBottom-in-d {
		width: 110px;
		height: 100%;
		/* background: red; */
		float: left;
		padding-top: 56px;
		box-sizing: border-box;
	}

	.pageBottom-in-a-logo {
		width: 69px;
		height: 46px;
		background: url(../assets/bottomLogo.png);
		background-size: 100% 100%;
	}

	.pageBottom-in-a-texta {
		width: 100%;
		height: auto;
		font-size: 14px;
		color: #a9a9a9;
		padding-top: 30px;
		box-sizing: border-box;
	}

	.pageBottom-in-a-textb {
		width: 100%;
		height: auto;
		font-size: 14px;
		color: #a9a9a9;
		padding-top: 10px;
		box-sizing: border-box;
	}
	.pageBottom-in-a-textb a{
		color: #A9A9A9;
	}

	.pageBottom-in-b-item {
		width: 100%;
		text-align: center;
		margin-bottom: 12px;
		box-sizing: border-box;
		font-size: 14px;
		color: #a9a9a9;
	}
	.pageBottom-in-b-item:hover{
		color: #009C41;
	}

	.pageBottom-in-b-item-tit {
		font-size: 16px;
		color: #e1e1e1;
		margin-bottom: 20px;
	}

	.pageBottom-in-c-item {
		width: 100%;
		/* text-align: center; */
		margin-bottom: 12px;
		box-sizing: border-box;
		font-size: 14px;
		color: #ffffff;
	}

	.pageBottom-in-c-item-tit {
		font-size: 16px;
		color: #ffffff;
		margin-bottom: 20px;
	}

	.pageBottom-in-d-code {
		width: 100%;
		height: 110px;
		background: #E1E1E1;
	}

	.pageBottom-in-d-text {
		width: 100%;
		font-size: 14px;
		color: #e1e1e1;
		text-align: center;
		padding-top: 10px;
		box-sizing: border-box;
	}
	@media only screen and (max-width: 1200px) {
		.pageBottom-in-c-item {
			width: 100%;
			text-align: center;
			margin-bottom: 12px;
			box-sizing: border-box;
			font-size: 14px;
			color: #ffffff;
		}
	}
</style>
